var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentPlus = function SvgDocumentPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    style: {
      enableBackground: "new 0 0 20 20"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8.67c-.11-.313-.17-.65-.17-1v-.5H12a3 3 0 1 1 0-6h.5V12a3 3 0 0 1 5.5-1.659V7.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 0-.5-.5H4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13 0 5 5h-4.5a.5.5 0 0 1-.5-.5V0ZM15.5 11a1 1 0 0 1 1 1v2.5H19a1 1 0 1 1 0 2h-2.5V19a1 1 0 1 1-2 0v-2.5H12a1 1 0 1 1 0-2h2.5V12a1 1 0 0 1 1-1Z"
  })));
};
export default SvgDocumentPlus;